import { render, staticRenderFns } from "./Modal-noti.vue?vue&type=template&id=ddcdaf5e&scoped=true"
import script from "./Modal-noti.vue?vue&type=script&lang=js"
export * from "./Modal-noti.vue?vue&type=script&lang=js"
import style0 from "./Modal-noti.vue?vue&type=style&index=0&id=ddcdaf5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcdaf5e",
  null
  
)

export default component.exports